import {
  I18nString,
  Settings,
  Factory,
  Deletable,
  Identifiable,
  Modifiable,
} from '../'
import { applyEntitySchema } from '../../_utils/fcdc-v2'
import { isPlainObject } from '../../_utils/fcdc-v2/json'
import { CustomerSchema } from '../schema/owners.schema'

export class Customer implements Identifiable, Modifiable, Deletable {
  id: string
  settings?: Settings
  names: I18nString[]
  deleted: boolean
  created: Date
  modified: Date

  constructor(json: any) {
    this.id = json.id
    this.settings = isPlainObject(json.settings)
      ? new Settings(json.settings)
      : undefined
    this.names = Array.isArray(json.names)
      ? json.names.map((name: any) => new I18nString(name))
      : []
    this.deleted = json.deleted ? Boolean(json.deleted) : false
    this.created = new Date(json.created)
    this.modified = new Date(json.modified)
    applyEntitySchema(this, CustomerSchema, json, {
      names: [],
      settings: undefined,
    })
  }

  static getFactory(): Factory<Customer> {
    return new (class implements Factory<Customer> {
      make(json: any): Customer {
        return new Customer(json)
      }

      getTableName(): string {
        return 'customers'
      }
    })()
  }

  static getUrl(customerId?: string): string {
    return `/customers` + (customerId ? '/' + customerId : '')
  }
}
